// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cRPYk","label":"styles_label__1CryF"};